<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>Warenausgang an Kunden anlegen</modal-header>
            <modal-content>
                <card class="card--minify card--message error " v-if="form.errors.ups">
                    <card-content v-html="form.errors.ups"></card-content>
                </card>

                <form-datepicker id="delivery_at" label="Ausgangsdatum" name="delivery_at"
                                 v-model:date="form.delivery_at" :error="form.errors.delivery_at"/>

                <form-input id="amount" :label="'Stückzahl (max '+maxOutgoingQty+' Stück)'" name="amount" v-model="form.amount"
                            :error="form.errors.amount" autocomplete="off"/>

                <form-text id="comment" label="Kommentar"
                           info="Text der im PDF nach der Anrede angezeigt wird, sollte zwei Zeilen nicht überschreiten"
                           name="comment" v-model="form.comment" :error="form.errors.comment"/>

                <form-select id="admin_user_id" label="Bearbeitet von" name="admin_user_id"
                             :options="adminUserOptions" v-model="form.admin_user_id"
                             :error="form.errors.admin_user_id"/>

                <form-select id="labels" label="Anzahl UPS Pakete" name="labels" @change="setUps"
                             :options="upsLabelOptions" v-model="form.labels"/>

                <form-group v-for="(ups, index) in form.ups" :key="ups.index">
                    <form-input id="ups_0_height" label="Höhe (cm)" name="ups[0][height]" v-model="ups.height"
                                :error="form.errors[`ups.${index}.height`]" autocomplete="off"/>
                    <form-input id="ups_0_width" label="Breite (cm)" name="ups[0][width]" v-model="ups.width"
                                :error="form.errors[`ups.${index}.width`]" autocomplete="off"/>
                    <form-input id="ups_0_length" label="Länge (cm)" name="ups[0][length]" v-model="ups.length"
                                :error="form.errors[`ups.${index}.length`]" autocomplete="off"/>
                    <form-input id="ups_0_weight" label="Gewicht (kg)" name="ups[0][weight]" v-model="ups.weight"
                                :error="form.errors[`ups.${index}.weight`]" autocomplete="off"/>
                </form-group>

                <div style="display: none;">
                    <form-checkbox id="send_email" option="Kunden informieren" v-model:checked="form.send_email" />
                </div>

            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="form.processing" :class="{'btn--processing': form.processing}">Speichern</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import {useForm} from '@inertiajs/vue3';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormText from '@partfactory/Shared/Form/FormText';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';
import FormGroup from '@partfactory/Shared/Form/FormGroup';
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormCheckbox from '@partfactory/Shared/Form/FormCheckbox';

export default {
    name: 'OutgoingGoodsClientModal',
    components: {
        FormCheckbox,
        CardContent,
        Card,
        FormGroup,
        FormDatepicker, FormText, FormInput, FormSelect, FormButton, ModalActions, Modal, ModalContent, ModalHeader
    },
    props: {
        askForQuote: Object,
        adminUsers: Object,
    },
    emit: ['closeDialog'],
    data() {
        let upsLabelOptions = [];
        for (let i = 1; i < 99; i++) {
            upsLabelOptions.push({text: i, value: i});
        }
        const currentDate = this.$moment(new Date, 'YYYY-MM-DD').format('YYYY-MM-DD');

        if (this.askForQuote?.client_user?.language === 2) {
            this.$language.current = 'en';
        }

        const comment = this.$gettext('vielen Dank für Ihren Auftrag an PART FACTORY. Basierend auf Ihrer Bestellung liefern wir Ihnen folgenden Artikel:');

        this.$language.current = 'de';

        const form = useForm({
            delivery_at: currentDate,
            amount: null,
            comment: comment,
            admin_user_id: this.$page.props.user.id,
            labels: [],
            ups: [],
            send_email: true,
        });

        return {upsLabelOptions, form};
    },
    computed: {
        adminUserOptions() {
            let adminUserOptions = [];
            this.adminUsers.forEach(adminUser => {
                adminUserOptions.push({value: adminUser.id, text: adminUser.name});
            });

            return adminUserOptions;
        },
        maxOutgoingQty() {
            let maxOutgoingQty = 0;
            this.askForQuote?.incoming_goods_producer?.forEach((incoming) => {
               maxOutgoingQty += incoming.amount;
            });

            this.askForQuote?.outgoing_goods_client?.forEach((outgoing) => {
               maxOutgoingQty -= outgoing.amount;
            });
            return maxOutgoingQty;
        },
    },
    methods: {
        setUps() {
            this.form.ups = [];
            for (let i = 0; i < this.form.labels; i++) {
                this.form.ups.push(
                    {
                        'height': null,
                        'width': null,
                        'length': null,
                        'weight': null,
                    }
                );
            }
        },
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                    send_email: this.form.send_email ? 'true' : '',
                }))
                .post(this.$$route('ask-for-quote.delivery.outgoing-goods-client', {'askForQuote': this.askForQuote.id}), {
                    onSuccess: () => this.$emit('closeDialog'),
                });
        },
    },
};
</script>
